import { STAGE } from '@/const/env.ts';

export const DEPLOY_PATH: string = 'beta';

export const NINJA_CDN = 'https://ninja.data.olxcdn.com';

export const SPLITTER_CDN = 'https://laquesis.data.olxcdn.com';

export const JSQR_URL = 'https://www.unpkg.com/jsqr@1.4.0/dist/jsQR.js';

export const HYDRA_HOST = 'https://tracking.olx-st.com/h/v2';

export const DEBUG_STREAM = 'eu-ninja-debug';

// TODO: make this redirect in CF function
export const LAQUESIS_SURVEY_JS_URL = `${NINJA_CDN}/${DEPLOY_PATH}/laquesisSurvey-${STAGE}.js`;

export const LAQUESIS_SURVEY_CSS_FILENAME = 'laquesis-survey';

/**
 * This is different from `Channel` - it is the user value that CUs use identify the platform.
 * `userProps[hydraConfig.platform_property]` is set to be one of these values.
 */
export const Platform = {
  Mobile: 'mobile-html5',
  Desktop: 'desktop',
} as const;

/**
 * Property, added to each event in the dataLayer. It is the moment when the event was generated.
 */
export const TIMESTAMP_PROP = '$T$';

export const ONAP_EXPIRATION_IN_DAYS = 365;

export const ONAP_SESSION_ACTIVE_DURATION = 1800 * 1000; // in ms

/**
 * Adapt apps' logic to web.
 * The value is a number where 0 means that the app is in the foreground and it's active, 1 - the app is in the foreground but not active for any reason, and 2 - the app in the background and it's not visible to the user
 * @see https://console.data.olx.org/user-behaviour/all-products/motors/properties/motors.as/trackers
 */
export const VISIBILITY_STATE = {
  ACTIVE: 0,
  INACTIVE_VISIBLE: 1,
  HIDDEN: 2,
};

/**
 * Sheep (bot) detection states
 * @see https://console.data.olx.org/user-behaviour/all-products/real-estate/properties/real-estate.sh/trackers
 */
export const SHEEP_STATE = {
  HUMAN: 0,
  BOT: 1,
  UNKNOWN: -1,
};
